module.exports = __webpack_public_path__ + "img/slide4.906af42b.webp";